export class ContentVacationTrip {
  deltaVacationTitle: string;
  deltaVacationUrl: string;
  deltaVacationOpenNewWindow: string;
  viewTripDetailsTitle: string;
  viewTripDetailsOpenNewWindow: string;
  checkInTitle: string;
  checkInOpenNewWindow: string;
  viewAllTripsOpenNewWindow: string;
  findMyTripsTitle: string;
  findMyTripsUrl = '';
  findMyTripsOpenNewWindow: string;
  hotelReservationTitle: string;
  carReservationLabel: string;
  hotelReservationUrl: string;
  hotelReservationOpenNewWindow: string;
  viewBoardingPassTitle: string;
  viewBoardingPassOpenNewWindow: string;
  viewAllTripsTitle: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['deltaVacationTitle']) {
        this.deltaVacationTitle = contentjson['deltaVacationTitle'];
      }
      if (contentjson['deltaVacationUrl']) {
        this.deltaVacationUrl = contentjson['deltaVacationUrl'];
      }
      if (contentjson['deltaVacationOpenNewWindow']) {
        this.deltaVacationOpenNewWindow =
          contentjson['deltaVacationOpenNewWindow'];
      }
      if (contentjson['viewTripDetailsTitle']) {
        this.viewTripDetailsTitle = contentjson['viewTripDetailsTitle'];
      }
      if (contentjson['viewTripDetailsOpenNewWindow']) {
        this.viewTripDetailsOpenNewWindow =
          contentjson['viewTripDetailsOpenNewWindow'];
      }
      if (contentjson['checkInTitle']) {
        this.checkInTitle = contentjson['checkInTitle'];
      }
      if (contentjson['checkInOpenNewWindow']) {
        this.checkInOpenNewWindow = contentjson['checkInOpenNewWindow'];
      }
      if (contentjson['viewAllTripsOpenNewWindow']) {
        this.viewAllTripsOpenNewWindow =
          contentjson['viewAllTripsOpenNewWindow'];
      }
      if (contentjson['findMyTripsTitle']) {
        this.findMyTripsTitle = contentjson['findMyTripsTitle'];
      }
      if (contentjson['findMyTripsUrl']) {
        this.findMyTripsUrl = contentjson['findMyTripsUrl'];
      }
      if (contentjson['findMyTripsOpenNewWindow']) {
        this.findMyTripsOpenNewWindow = contentjson['findMyTripsOpenNewWindow'];
      }
      if (contentjson['hotelReservationTitle']) {
        this.hotelReservationTitle = contentjson['hotelReservationTitle'];
      }
      if (contentjson['carReservationLabel']) {
        this.carReservationLabel = contentjson['carReservationLabel'];
      }
      if (contentjson['hotelReservationUrl']) {
        this.hotelReservationUrl = contentjson['hotelReservationUrl'];
      }
      if (contentjson['hotelReservationOpenNewWindow']) {
        this.hotelReservationOpenNewWindow =
          contentjson['hotelReservationOpenNewWindow'];
      }
      if (contentjson['viewBoardingPassTitle']) {
        this.viewBoardingPassTitle = contentjson['viewBoardingPassTitle'];
      }
      if (contentjson['viewBoardingPassOpenNewWindow']) {
        this.viewBoardingPassOpenNewWindow =
          contentjson['viewBoardingPassOpenNewWindow'];
      }
      if (contentjson['viewAllTripsTitle']) {
        this.viewAllTripsTitle = contentjson['viewAllTripsTitle'];
      }
    }
  }
}
